import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useDesktopStyles = makeStyles(theme => ({
  priceBlock: {
    minWidth: 332,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[300]}`
  }
}))
